import i18next from "i18next";
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import UploadedFileCard from "../component/InputsTypesComponents/AddInvestigationInput/UploadedFileCard";
import { gridColsMap } from "../../../Constants/SocialLinks";
import { MedicalFields } from "../../../enums/MedicalReportEnums";
import { IStepFields } from "../../../interface/MedicalRecord";
import { toSnakeCase } from "../../../utils/fileUtils";
import { formattedMedicalInputValue } from "../utils";
import RepeaterRender from "../component/RepeatableSection/RepeaterRender/RepeaterRender";

interface RecordValueRendererProps {
  field: IStepFields;
  data?: any;
}

export const RecordValueRenderer: React.FC<RecordValueRendererProps> = ({
  field,
  data,
}) => {

  const { t } = useTranslation();
  const fieldValue =
    ((field?.Value?.length ?? 0) > 0 ? field?.Value : undefined) ??
    field?.InverseParentStepFields ?? field?.RepeatedGroups;
  const filteredKeys = Object.keys(fieldValue?.[0] || {});
  const fieldSelectedOption = field?.InverseParentStepFields?.find(
    (option) => option?.Selected && option?.Type === MedicalFields.Option,
  );

  const radioHasValue=(field?.Type==MedicalFields.Radio) ?  fieldSelectedOption :true
   const RepeatedHasValue=(field?.Type==MedicalFields.Repeater) ?  field?.RepeatedGroups?.length ?? 0 > 0 :true

  const gridColsClass =
    gridColsMap[filteredKeys?.length as keyof typeof gridColsMap] ||
    "grid-cols-1 text-sm";


  const parseValue = (value: any) => {
    if (typeof value !== "string") {
      return value;
    }

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  };

  const renderField = () => {

    switch (field.Type) {
      case MedicalFields.MultiFile:

        const files = fieldValue
          ? parseValue(fieldValue as any)
          : [];

        return (
          <div className="grid h-full w-full grid-cols-2 items-center gap-4 text-sm">
            {files?.map((file: any, index: number) => {
              return (
                <UploadedFileCard
                  key={index}
                  showRemove={false}
                  field={file as any}
                  item={file as any}
                />
              );
            })}
          </div>
        );

      case MedicalFields.TextEditor:
        return (
          <div
            className="TextEditor rounded-lg p-4 text-sm"
            dangerouslySetInnerHTML={{ __html: fieldValue as any }}
          />
        );
      case MedicalFields.Date:
        return (
          <div className={`w-full rounded-lg p-2 text-sm font-bold`}>
            {moment(String(fieldValue), "DD-MM-YYYY", "en")
              .locale(i18next?.language)
              .format("DD MMMM, YYYY")}
          </div>
        );

      case MedicalFields.Radio:
        return (
          <div
            className={`flex w-full flex-col justify-between rounded-lg p-2 text-sm font-bold`}
          >
            <div>{fieldSelectedOption?.Name}</div>{" "}
            {(fieldSelectedOption?.InverseParentStepFields?.length ?? 0) >
              0 && (
                <div className="p-2 shadow-md flex flex-col gap-2">
                  {fieldSelectedOption?.InverseParentStepFields?.map(
                    (item, index) => {
                      return item?.Type !== MedicalFields.Option ? (
                        <RecordValueRenderer key={index} field={item} />
                      ) : (
                        <></>
                      );
                    },
                  )}

                  {/* {field?.InverseParentStepFields?.map((item, index) => {
                    return item?.Type !== MedicalFields.Option ? (
                      <RecordValueRenderer key={index} field={item} />
                    ) : (
                      <></>
                    );
                  })} */}
                </div>
              )}
          </div>
        );
      case MedicalFields.Select:
        return (
          <div
            className={`flex w-full justify-between rounded-lg p-2 text-sm font-bold`}
          >
            <div>{fieldSelectedOption?.Name}</div>
            {(fieldSelectedOption?.InverseParentStepFields?.length ?? 0) >
              0 && (
                <div className="p-2 shadow-md flex flex-col gap-2">
                  {fieldSelectedOption?.InverseParentStepFields?.map(
                    (item, index) => {
                      return <RecordValueRenderer key={index} field={item} />;
                    },
                  )}
                </div>
              )}
          </div>
        );
      case MedicalFields.Repeater:
        return (
          <RepeaterRender field={field} />
        );

      default:
        return (
          <p className="text-sm py-1">
            {!Array.isArray(fieldValue) ? (
              formattedMedicalInputValue(fieldValue, t) + " "+
              (field?.Unit ?? "")
            ) : (
              <div>
                <div className={`grid ${gridColsClass}`}>
                  {filteredKeys?.map((key: string, i: number) => {
                    return (
                      <div className="mb-1.5 font-bold" key={i}>
                        {t(toSnakeCase(key))}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </p>
        );
    }
  };

  return (fieldValue && radioHasValue && RepeatedHasValue) ? (
    <>
      <p className="text-body-text text-sm">{field?.Name}</p>
      {renderField()}

      {field?.InverseParentStepFields?.map((item, index) => {
        return (item?.Type !== MedicalFields.Option &&
          item?.Type !== MedicalFields.MultiFile
        ) ? (
          <RecordValueRenderer key={index} field={item} />
        ) : (
          <></>
        );
      })}
    </>
  ) : (
    <></>
  );
};
